export const INSURANCE_DOCUMENTS_OPTIONS = [
  { label: 'Upload Now', key: false },
  { label: 'I don’t have it. <span>Remind me later.</span>', key: true },
];
